'use client';

import { useEffect } from 'react';
import ReactPixel from 'react-facebook-pixel';

const MetaPixel = () => {
  useEffect(() => {
    // Ensure the code runs only on the client side
    if (typeof window !== 'undefined') {
      const options = {
        autoConfig: true,
        debug: true, // Enable debug logging
      };

      const pixelKey = process.env.NEXT_PUBLIC_APP_META_PIXEL_KEY || '1613991859107974';
      ReactPixel.init(pixelKey, undefined, options);
      ReactPixel.pageView();

    }
  }, []);

  return null;
};

export default MetaPixel;